import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isExperienceDashEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isExperienceDashEnabled>[0];
  isLoading: boolean;
}>;

export default function ExperienceDashRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isExperienceDashEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
